import { connect } from "react-redux"
import { merklistenSelector } from "../../../modules/selectors/merkliste"
import { addToMerkliste, removeFromMerkliste } from "../../../modules/actions/merkliste"
import { markenStandortSelector } from "../../../modules/selectors/standort/markenStandort"
import { toast } from "../../../helpers/toastHelper"
import { useEffect, useState } from "react"
import { useLocation } from "react-router-dom"
import { useStandortHistory } from "../../components/VHost/StandortHistory"
import { trackEvent } from "../../components/Tracking/Matomo"

function isOnMerkliste(merkliste, { productId, selectedVariant, standortId }) {
    if (!Array.isArray(merkliste) || !standortId) {
        return false;
    }

    const ids = new Set(
        [productId, selectedVariant]
            .filter(id => id != null && id !== '')
            .map(id => String(id))
    );

    if (ids.size === 0) {
        return false;
    }

    return merkliste.some(entry =>
        String(entry.standort) === String(standortId) &&
        (ids.has(String(entry.productId)) || ids.has(String(entry.selectedVariant)))
    );
}

function MerklisteButton({ markenStandort, merkliste, productId, categoryUrl, selectedVariant, position = "absolute", removeFromMerkliste, addToMerkliste, productName }) {
    const history = useStandortHistory()
    const location = useLocation()
    const standortId = markenStandort?._id
    const isMerklistePage = location.pathname.endsWith('/merkliste')
    const [onList, setOnList] = useState(false)

    useEffect(() => {
        setOnList(isOnMerkliste(merkliste, { productId, selectedVariant, standortId }))
    }, [merkliste, productId, selectedVariant, standortId])

    useEffect(() => {
        window.merklistenRedirectHandler = function (path) {
            history.push({ pathname: path });
        }
    }, [history])

    const onClick = async () => {
        if (!standortId) {
            return
        }

        const entry = { productId, categoryUrl, selectedVariant, standort: standortId }

        if (onList) {
            await removeFromMerkliste(entry)
            trackEvent({ category: 'Merkliste', action: 'Remove-Entry', label: productId });
            toast({ message: "Vom Merkzettel entfernt!<button class='merklisten_redirect merklist' onClick={window.merklistenRedirectHandler('/merkliste')}>Merkzettel anzeigen</button>", status: 'success' });
        } else {
            await addToMerkliste(entry)
            trackEvent({ category: 'Merkliste', action: 'Add-Entry', label: productId });
            toast({ message: "Gespeichert!<button class='merklisten_redirect' onClick={window.merklistenRedirectHandler('/merkliste')}>Merkzettel anzeigen</button>", status: 'success' });
        }
    }

    const ariaLabel = isMerklistePage
        ? "Aus Merkzettel entfernen"
        : onList
            ? (productName ? `${productName.replace(/<[^>]*>/g, '')} aus Merkzettel entfernen` : "Aus Merkzettel entfernen")
            : (productName ? `${productName.replace(/<[^>]*>/g, '')} zum Merkzettel hinzufügen` : "Zum Merkzettel hinzufügen")

    return (
        <div className="merkliste-button-wrapper" style={{ position }}>
            <button
                type="button"
                className="merkliste-button"
                onClick={onClick}
                aria-label={ariaLabel}
                aria-pressed={onList}
            >
                {onList ? 
                    <i
                        className={isMerklistePage ? "fa fa-trash-o" : "fa fa-heart"}
                        aria-hidden="true"
                    />
                :
                    <i
                        className="fa fa-heart-o"
                        aria-hidden="true"
                    />
                }
            </button>
        </div>
    )
}

const mapStateToProps = state => ({
    merkliste: merklistenSelector(state),
    markenStandort: markenStandortSelector(state),
});

const mapDispatchToProps = { removeFromMerkliste, addToMerkliste };

export default connect(mapStateToProps, mapDispatchToProps)(MerklisteButton);
